const Skills = () => {
	return (
		<article>
			<h2>Technology Expertise</h2>
			<ul id="tech-expertise-list">
				<li>AWS</li>
				<li>CSS</li>
				<li>git</li>
				<li>GraphQL</li>
				<li>HTML</li>
				<li className="color-accent">Javascript</li>
				<li className="color-accent">Node.js</li>
				<li>npm</li>
				<li className="color-accent">React</li>
				<li>Redux</li>
				<li>Sass</li>
				<li>Sketch</li>
				<li className="color-accent">Typescript</li>
				<li>Webpack</li>
			</ul>
		</article>
	);
};

export default Skills;
